import { watch } from "vue";
const hydrate = (options) => {
  if (!options?.isDark) {
    console.warn("hydrateImages called without isDark ref");
    return false;
  }
  const { isDark } = options;
  const toggleImages = [];
  watch(isDark, () => {
    if (isDark.value) {
      toggleImages.forEach((img) => {
        img.src = img.dataset.darkModeSrc || "";
      });
    } else {
      toggleImages.forEach((img) => {
        img.src = img.dataset.src || "";
      });
    }
  });
  const images = document.querySelectorAll(
    `[data-scalar-type="image"][data-dark-mode-src]:not([hydrated])`
  );
  images.forEach((element) => {
    const darkModeSrc = element.dataset.darkModeSrc;
    if (darkModeSrc) {
      toggleImages.push(element);
      if (isDark.value) element.src = darkModeSrc;
      element.setAttribute("hydrated", "true");
    }
  });
  return true;
};
export {
  hydrate
};
//# sourceMappingURL=hydration.js.map
